<template>
  <b-modal 
    :id="modalId"
    class="modal-warning"
    :header-class="header.class"
    :body-class="body.class"
    :footer-class="footer.class"
    :size="size"
    @hide="closeModal"
    @hidden="onModalHidden"
  >
    <template #modal-header>
      <div class="modal-title fs-db-28">
        <span v-html="title"></span>
      </div>
      <div
        id="modal-close"
        type="button"
        class="close-modal close"
        aria-label="Close"
        @click="closeModal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>

    <template>
      <div class="fs-sa-16" v-html="message"></div>
    </template>

    <template #modal-footer>
      <Button
        v-if="_confirm.isEnable"
        id="modal-confirm"
        style="min-width: 96px;"
        :label="_confirm.text"
        :isIcon="_confirm.icon.isEnable"
        :iconClass="_confirm.icon.class"
        :iconPosition="_confirm.icon.position"
        :btnStyle="_confirm.variant"
        @click="onConfirm"
      />
      <Button
        v-if="_cancel.isEnable"
        id="modal-cancel"
        style="min-width: 96px;"
        :label="_cancel.text"
        :isIcon="_cancel.icon.isEnable"
        :iconClass="_cancel.icon.class"
        :iconPosition="_cancel.icon.position"
        :btnStyle="_cancel.variant"
        @click="onCancel"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@components_system/Shared/Elements/Button/Button";

export default {
  components: {
    Button
  },
  data() {
    return {
      modalId: 'modal-confirm-warning',
    }
  },
  watch: {
    modalActive: {
      handler(next) {
        if (next == this.modalId) {
          this.$bvModal.show(this.modalId);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      modalActive: "design/modals/modalActive",
      modalsID: "design/modals/modalsID",
      modals: "design/modals/modals",
    }),
    modal() {
      if (!this.modalsID.includes(this.modalId)) return null;
      return this.modals[this.modalId];
    },
    variant() {
      return 'warning'
    },
    size() {
      return 'md'
    },
    title() {
      return this.modal && this.modal.payload && this.modal.payload.title ? this.modal.payload.title : 'Info Alert Dialog'
    },
    message() {
      return this.modal && this.modal.payload && this.modal.payload.message ? this.modal.payload.message : 'This is a Info alert message modal.'
    },
    confirm() {
      return { text: 'Ok', icon: 'far fa-check' }
    },
    cancel() {
      return { text: 'Cancel', icon: 'far fa-times' }
    },
    header() {
      return {
        class: {
          'warning': true,
          'align-items-center': true,
          'px-20': true, 
          'py-15': true,
          'text-danger-dark2': this.variant == 'danger',
        }
      }
    },
    body() {
      return {
        class: {
          'p-20': true, 
        }
      }
    },
    footer() {
      return {
        class: {
          'px-20': true, 
          'py-15': true, 
        }
      }
    },
    _confirm() {
      return {
        isEnable: true,
        variant: "primary",
        text: "Ok",
        icon: {
          isEnable: true,
          class: "far fa-check",
          position: "left"
        }
      }
    },
    _cancel() {
      return {
        isEnable: true,
        variant: "default",
        text: "Cancel",
        icon: {
          isEnable: true,
          class: "far fa-times",
          position: "left"
        }
      }
    },
    iconConfirm() {
      return {
        isEnable: true,
        class: "far fa-check",
        position: "left"
      }
    },
    iconCancel() {
      return {
        isEnable: true,
        class: "far fa-times",
        position: "left"
      }
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
    onModalHidden() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalId,
        clear: true,
        func: 'close',
        data: {}
      },{ root:true });
    },
    onCancel() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalId,
        clear: true,
        func: 'cancel',
        data: {}
      },{ root:true });
      this.closeModal();
    },
    onConfirm() {
      this.$store.dispatch("designIframe/modals/callback", {
        key: this.modalId,
        clear: true,
        func: 'confirmed',
        data: {},
      },{ root:true });
      this.closeModal();
    },
  },
};
</script>